import { Component, ViewChild } from '@angular/core';
import {
  FormArray,
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
//import { DeviceDetectorService } from 'ngx-device-detector';
import { LoaderService } from '../../../core/services/loader.service';
import { SharedService } from '../../../shared/shared.service';
import { Validations } from '../../../shared/constants/validations';
//import { LeakdetectorsService } from '../../../core/services/leakdetectors.service';
import { SweetAlertIcon } from '../../../shared/constants/enum';
//import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { LocalStorageService } from './../../../core/services/localStorage.service';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent {
  gasLeakRegistrationUrl = environment?.gasLeakRegistrationUrl;
  //Prod Url
 // gasLeakRegistrationUrl = 'https://ripple-auth-app-prod.azurewebsites.net/v1/LeakDetectingDevice/register-leak-detect-device';//Prod Url

  //uat
 // gasLeakRegistrationUrl = 'https://ripple-auth-api-uat.azurewebsites.net/v1/LeakDetectingDevice/register-leak-detect-device'; // UAT Url

  isDeviceIdUrl = 'https://conference.ripplemetering.com/backend/public/api/fetchDeviceUserInfo'
  breadCrumbItems: Array<{}> | undefined;
  configData: any;
  regex = /^[a-zA-Z0-9,#\-\/]+(?: [a-zA-Z0-9,#\-\/]+)*$/;
  emailRgex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$';
  nameRegex = '^[A-Za-z]+( [A-Za-z]+)*$';
  IsnewUsersubmitted: boolean = false;
  IsExstingUsersubmitted: boolean = false;
  prifileValidations = Validations;
  newUserForm!: UntypedFormGroup;
  exstingUserForm!: UntypedFormGroup;
  PrimaryCountryCode: any;
  isExstingUserCountryCode: any;
  valiadationMessage: String = '';
  exstinguserValidationsMessage: String = '';
  isMobile = false;
  isTablet = false;
  isDesktop = false;
  isScanning = false;
  isDeviceIdValid: boolean = false;
  isdeviceIdExstingUserValid: boolean = false;
  deviceIdList: any[] = [];
  isdeviceId: boolean = false;
  isisdeviceIdExstingUser: boolean = false;
  newuserDeviceIdresult: any;
  exstinguserDeviceIdresult: any;
  /* @ViewChild(ZXingScannerComponent) */
  // scanner!: ZXingScannerComponent;
  allowedFormats = [
    'QR_CODE',
    'CODE_128',
    'EAN_13',
    'EAN_8'
  ];

  countryCodes =
    [
      {
        "id": "017719b4-ee02-42cd-9a1c-462233ba179b",
        "name": "United Arab Emirates",
        "code": "+971",
        "shortName": "UAE"
      },
      {
        "id": "5ba75b79-bb6d-44c6-9908-b46704c7c2b3",
        "name": "India",
        "code": "+91",
        "shortName": "IN"
      },
      {
        "id": "cee2f2c7-5995-4e7e-9108-6cbfc36c5563",
        "name": "China",
        "code": "+86",
        "shortName": "CN"
      },
      {
        "id": "89e4a870-e75f-47fd-af6d-de026ef0d9ae",
        "name": "United States",
        "code": "+1",
        "shortName": "US"
      }
    ]

  deviceid = [
    {
      "first_name": "gandikota",
      "last_name": "rama krishna",
      "mobile": "9000515202",
      "email": "ramagkrishna91@gmail.com",
      "flat_no": "201",
      "floor": "2nd",
      "tower": "A",
      "block": "A",
      "address": "dnod3",
      "registered_at": "2026-01-01 19:07:36",
      "device_id": 'SGLD123475'
    },
    {
      "first_name": "Amery",
      "last_name": "Hunter",
      "mobile": "9000515202",
      "email": "koma@mailinator.com",
      "flat_no": "Et",
      "floor": "Vol",
      "tower": "Ea",
      "block": "Tem",
      "address": "Aliquam voluptas dolor dolorum voluptatem elit quasi",
      "registered_at": "2025-12-24 19:53:33",
      "device_id": 'SGLD123464'
    },
    {
      "first_name": "rama",
      "last_name": "krishna",
      "mobile": "9000515202",
      "email": "ramagkrishna91@gmail.com",
      "flat_no": "A",
      "floor": "1",
      "tower": "1",
      "block": "1",
      "address": "Test address in hyd",
      "registered_at": "2026-01-06 20:53:39",
      "device_id": 'SGLD340EFC'
    }
  ]

  constructor(private loaderService: LoaderService,
    // private leakdetectorsService: LeakdetectorsService,
    private http: HttpClient,
    private sharedService: SharedService,
    private router: Router,
    private formBuilder: UntypedFormBuilder) {
    // this.getAllConfigData()
    this.createUsersForm();
    // this.isDesktop = this.deviceService.isDesktop();
    // this.isMobile = this.deviceService.isMobile();
    // console.log('Mobile:', this.deviceService.isMobile());
    // console.log('Tablet:', this.deviceService.isTablet());
    // console.log('Desktop:', this.deviceService.isDesktop());
    // this.deviceInfo = this.deviceService.getDeviceInfo();
    //  console.log(this.deviceService.getDeviceInfo());
    this.exstingUserForm = this.formBuilder.group({
      /* name: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(25),
        Validators.pattern(this.nameRegex),
      ]],
      email: ['', [

        Validators.pattern(this.emailRgex),
        Validators.maxLength(50),
      ]], */
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(/^[6-9]\d{9}$/),
        ],
      ],
      countrycode: [null, [Validators.required]],
      deviceId: [
        null,
        [
          Validators.required,
          /*  Validators.maxLength(10),
           Validators.minLength(10),
           Validators.pattern(/^(?=.*[A-Za-z0-9])[A-Za-z0-9]+( [A-Za-z0-9]+)*$/), */
        ],
      ],
      installedLocation: [
        '',
        [Validators.required, Validators.pattern(/^(?!\s*$)[A-Za-z0-9 ]+$/)],
        /* [
          Validators.required,
          Validators.pattern(/^(?!\s*$)[A-Za-z0-9 ]+$/)
        ] */
      ],
    });
  }

  ngOnInit(): void {
    window.location.assign("https://www.ripplesafehome.com/device-registration")
    this.breadCrumbItems = [
      { label: 'Smart Leak Devices' },
      { label: 'Registration', active: true }
    ];
  }
  /*  getAllConfigData(): void {
     let payload = ['countryCodes'];
     this.sharedService.getAllConfigData(payload).subscribe((data) => {
       if (
         data.statusCode == 200 &&
         data.message == 'Config data retrieved successfully.'
       ) {
         this.configData = data?.data;
         this.loaderService.setLoading(false);
         console.log(this.configData);
       }
     })
   } */
  createUsersForm() {
    this.newUserForm = this.formBuilder.group({

      name: [, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
        Validators.pattern(this.nameRegex),
      ]],
      deviceId: [
        null,
        [
          Validators.required,
          /* Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern(/^(?=.*[A-Za-z0-9])[A-Za-z0-9]+( [A-Za-z0-9]+)*$/), */
        ],
      ],

      email: ['', [
       
        Validators.pattern(this.emailRgex),
        Validators.maxLength(50),
      ]],
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern(/^[6-9]\d{9}$/),
        ],
      ],
      countrycode: [null, [Validators.required]],

      deviceAddress: ['', [
        Validators.required,
        Validators.pattern(/^(?!\s*$)[A-Za-z0-9\/\-_&(),+ .#]+$/)]],
      flatNo: ['', [
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(10),
      ]],
      floor: ['', [
        Validators.pattern(this.regex),
        Validators.maxLength(5),
      ]],
      block: ['', [
        Validators.pattern(this.regex),
        Validators.maxLength(5),
      ]],
      tower: ['', [
        Validators.pattern(this.regex),
        Validators.maxLength(5),
      ]],
      installedLocation: [
        '',
        //[Validators.required, Validators.pattern(/^(?!\s*$)[A-Za-z0-9 ]+$/)],
        [
          Validators.required,
          Validators.pattern(/^(?!\s*$)[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/),
          Validators.maxLength(25)
        ]
      ],

    });

    /* this.newUserForm = this.formBuilder.group({
      // STEP 1 (Enabled)
      mobileNo: ['', Validators.required],
      deviceId: ['', Validators.required],

      // STEP 2 (Disabled initially)
      firstName: [{ value: '', disabled: true }, Validators.required],
      lastName: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      flatNo: [{ value: '', disabled: true }, Validators.required],
      tower: [{ value: '', disabled: true }],
      floor: [{ value: '', disabled: true }],
      block: [{ value: '', disabled: true }],
      address: [{ value: '', disabled: true }]
    }); */


  }
  get individualControls() {
    return this.newUserForm.controls;
  }
  get exstingUserControls() {
    return this.exstingUserForm.controls;
  }
  PrimaryvaliadationMobile(event: any) {
    this.PrimaryCountryCode = event.code;
    console.log(event);
    if (event.code == '+91') {
      this.individualControls['mobileNo'].setValidators([
        Validators.required,
        Validators.maxLength(10),
        Validators.minLength(10),
        Validators.pattern(/^[6-9]\d{9}$/),
      ]);
      this.individualControls['mobileNo'].updateValueAndValidity();
      this.valiadationMessage =
        'Mobile Number Should Conatines 10 characters';
    } else {
      this.individualControls['mobileNo'].clearValidators();
      this.individualControls['mobileNo'].updateValueAndValidity();
      this.valiadationMessage = '';
    }
  }
  exstingUseronMobile(event: any) {
    this.isExstingUserCountryCode = event.code;
    console.log(event);
    if (event.code == '+91') {
      this.exstingUserControls['mobileNo'].setValidators([
        Validators.required,
        Validators.maxLength(10),
        Validators.minLength(10),
        Validators.pattern(/^[6-9]\d{9}$/),
      ]);
      this.exstingUserControls['mobileNo'].updateValueAndValidity();
      this.exstinguserValidationsMessage =
        'Mobile Number Should Conatines 10 characters';
    } else {
      this.exstingUserControls['mobileNo'].clearValidators();
      this.exstingUserControls['mobileNo'].updateValueAndValidity();
      this.exstinguserValidationsMessage = '';
    }
  }

  /* isDeviceIdCheckNewUser() {
    this.loaderService.setLoading(true);
    this.IsnewUsersubmitted = true;
    const headers = new HttpHeaders({
      'x-auth-token': 'R7XST21TDH=G2=3R9WJDFC6IHE$ZVU9ZHP7ZZ34HWM==EHXBEA',
      'Content-Type': 'application/json'
    });
    console.log(this.newUserForm.value.mobileNo)
    console.log(this.newUserForm.valid)

    if (this.newUserForm.valid) {
      let request = {
        deviceId: this.newUserForm.value.deviceId,
      }
      this.http.post<any>(this.isDeviceIdUrl, request, { headers }
      ).subscribe({
        next: (res) => {
          console.log('res', res);
          this.isdeviceId = res.success; //if it true then only call new user create api 
          console.log('res', this.isdeviceId);
        
         
        
          this.loaderService.setLoading(false);
          if (this.isdeviceId) {
            if (this.newUserForm.value.mobileNo !== res.data.mobile) {
              this.isdeviceId = false
              const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-primary ms-2',
                },
                buttonsStyling: false,
              });
              swalWithBootstrapButtons
                .fire({
                  allowOutsideClick: false,
                  //title: 'Session out',
                  text: `The entered mobile number does not match the mobile number linked to the device ID.This Devcie Id is purchased with ${res.data.mobile}. Would you like to continue or cancel?`,
                  icon: 'warning',
                  confirmButtonText: 'Yes, Continue',
                  cancelButtonText: 'No, Cancel',
                  showCancelButton: true,
                  timerProgressBar: true,
                })
                .then((result) => {
                  console.log(result, 'result');
                  if (result.value) {
                    console.log(result.value)
                    this.newUserCreate()

                  } else {
                    console.log(result.value)
                    return;
                  }
                });
            } else {
              this.newUserCreate();
            }
          } else {
            console.warn(this.isdeviceId)
          }

        },

        error: (err) => {
          this.loaderService.setLoading(false);
          console.error(err);
          this.loaderService.setLoading(false);

          let errorMsg = 'Something went wrong. Please try again later.';

          // ✅ Handle validation error structure
          if (err?.error?.errors) {
            const errorsObj = err.error.errors;

            // take first validation message
            const firstKey = Object.keys(errorsObj)[0];
            if (firstKey && errorsObj[firstKey]?.length) {
              errorMsg = errorsObj[firstKey][0];
            }
          }
          // fallback
          else if (err?.error?.message) {
            errorMsg = err.error.message;
          }

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR
          );
        }
      });

    } else {
      this.loaderService.setLoading(false);
    }

  } */
  logout() {
    this.router.navigate(['/auth/login']);
    localStorage.clear();
  }
  /*   isDeviceIdCheckExstingUser() {
      this.loaderService.setLoading(true);
      this.IsExstingUsersubmitted = true;
      const headers = new HttpHeaders({
        'x-auth-token': 'R7XST21TDH=G2=3R9WJDFC6IHE$ZVU9ZHP7ZZ34HWM==EHXBEA',
        'Content-Type': 'application/json'
      });
      console.log(this.exstingUserForm.value.mobileNo)
      console.log(this.exstingUserForm.valid)
  
      if (this.exstingUserForm.valid) {
        let request = {
          deviceId: this.exstingUserForm.value.deviceId,
        }
        this.http.post<any>(this.isDeviceIdUrl, request, { headers }
        ).subscribe({
          next: (res) => {
            console.log('res', res);
            this.isdeviceId = res.success; //if it true then only call new user create api 
            this.loaderService.setLoading(false);
            if (this.isdeviceId) {
              if (this.exstingUserForm.value.mobileNo !== res.data.mobile) {
                this.isdeviceId = false
                const swalWithBootstrapButtons = Swal.mixin({
                  customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-primary ms-2',
                  },
                  buttonsStyling: false,
                });
                swalWithBootstrapButtons
                  .fire({
                    allowOutsideClick: false,
                    //title: 'Session out',
                    text: `The entered mobile number does not match the mobile number linked to the device ID.This Devcie Id is purchased with ${res.data.mobile}. Would you like to continue or cancel?`,
                    icon: 'warning',
                    confirmButtonText: 'Yes, Continue',
                    cancelButtonText: 'No, Cancel',
                    showCancelButton: true,
                    timerProgressBar: true,
                  })
                  .then((result) => {
                    console.log(result, 'result');
                    if (result.value) {
                      this.exstingUserCreate()
  
                    } else {
                      return;
                    }
                  });
              } else {
  
                this.exstingUserCreate()
              }
            } else {
              console.warn(this.isdeviceId)
            }
  
          },
  
          error: (err) => {
            this.loaderService.setLoading(false);
            console.error(err);
            this.loaderService.setLoading(false);
  
            let errorMsg = 'Something went wrong. Please try again later.';
  
            // ✅ Handle validation error structure
            if (err?.error?.errors) {
              const errorsObj = err.error.errors;
  
              // take first validation message
              const firstKey = Object.keys(errorsObj)[0];
              if (firstKey && errorsObj[firstKey]?.length) {
                errorMsg = errorsObj[firstKey][0];
              }
            }
            // fallback
            else if (err?.error?.message) {
              errorMsg = err.error.message;
            }
  
            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR
            );
          }
        });
  
      } else {
        this.loaderService.setLoading(false);
        console.log("data empty")
      }
  
    } */


  deviceIdchangesNewUser(event: any) {
    console.log(event);
    this.isDeviceIdValid = true;
    this.newuserDeviceIdresult = event;
    if (!event) {
      this.newuserDeviceIdresult = null;
      this.newUserForm.patchValue({
        name: '',
        email: '',
        flatNo: '',
        tower: '',
        floor: '',
        block: '',
        deviceAddress: '',
        installedLocation: ''
      });
      return;
    }

    this.newUserForm.patchValue({
      name: `${event.first_name} ${event.last_name}`.trim(),
      email: event.email,
      flatNo: event.flat_no || '',
      tower: event.tower || '',
      floor: event.floor || '',
      block: event.block || '',
      deviceAddress: event.address,
      installedLocation: event.installed_location
    });

  }

  deviceIdchangesExstinguser(event: any) {
    console.log(event);
    this.isdeviceIdExstingUserValid = true;
    this.exstinguserDeviceIdresult = event;
    if (!event) {
      this.exstinguserDeviceIdresult = null;
      this.newUserForm.patchValue({
        name: '',
        email: '',
        flatNo: '',
        tower: '',
        floor: '',
        block: '',
        deviceAddress: '',
        installedLocation: ''
      });
      return;
    }

    /* this.newUserForm.patchValue({
      name: `${event.first_name} ${event.last_name}`.trim(),
      email: event.email,
      flatNo: event.flat_no,
      tower: event.tower,
      floor: event.floor,
      block: event.block,
      deviceAddress: event.address,
      installedLocation: event.installed_location
    }); */

  }

  isDeviceIdCheckExstingUser() {
    if (
      this.exstingUserForm.get('mobileNo')?.invalid || this.exstingUserForm.get('countrycode')?.invalid
    ) {
      this.IsExstingUsersubmitted = true;
      this.exstingUserForm.get('mobileNo')?.markAsTouched();
      this.exstingUserForm.get('countrycode')?.markAsTouched();

      this.loaderService.setLoading(false);
      return;
    }
    const headers = new HttpHeaders({
      'x-auth-token': 'R7XST21TDH=G2=3R9WJDFC6IHE$ZVU9ZHP7ZZ34HWM==EHXBEA',
      'Content-Type': 'application/json'
    });
    let request = {
      mobile: this.exstingUserForm.value.mobileNo,
    }
    this.loaderService.setLoading(true);
   /*  this.isisdeviceIdExstingUser = true
    
    this.loaderService.setLoading(false);
    this.isisdeviceIdExstingUser = true
    this.deviceIdList = this.deviceid; */

     this.http.post<any>(this.isDeviceIdUrl, request, { headers }
     ).subscribe({
       next: (res) => {
         console.log('res', res);
         this.isDeviceIdValid = res.success; //for emable create device button and reaming feilds like name  email
         this.loaderService.setLoading(false);
         this.isdeviceIdExstingUserValid = res.success;
        // this.exstinguserDeviceIdresult = res.data
        // this.exstingUserForm.get('deviceId')?.disable();
         if (this.isdeviceIdExstingUserValid) {
           this.deviceIdList = [];
           this.isisdeviceIdExstingUser = true;
           this.deviceIdList = res.data.filter(
             (item :any)=> item.device_id && item.device_id.trim() !== ''
           );
           console.log(this.deviceIdList);
         }else{
            console.log('no device id found');
           this.deviceIdList = [];
           this.isisdeviceIdExstingUser = false
         }
         
        
       }, error: (err) => {
         this.loaderService.setLoading(false);
         console.error(err);
         this.loaderService.setLoading(false);
 
         let errorMsg = 'Something went wrong. Please try again later.';
 
         // ✅ Handle validation error structure
         if (err?.error?.errors) {
           const errorsObj = err.error.errors;
 
           // take first validation message
           const firstKey = Object.keys(errorsObj)[0];
           if (firstKey && errorsObj[firstKey]?.length) {
             errorMsg = errorsObj[firstKey][0];
           }
         }
         // fallback
         else if (err?.error?.message) {
           errorMsg = err.error.message;
         }
 
         this.sharedService.showMessageDialog(
           errorMsg,
           '',
           SweetAlertIcon.ERROR
         );
       }
     });
  }

  onStepChange(event: any) {
    console.log('Step changed to:', event);
    this.newUserForm.reset();
    this.IsnewUsersubmitted = false;
    this.isDeviceIdValid = false;
    this.deviceIdList = [];
    this.isdeviceId = false;
    this.exstingUserForm.reset();
    this.IsExstingUsersubmitted = false;
    this.isdeviceIdExstingUserValid = false;
    this.deviceIdList = [];
    this.isisdeviceIdExstingUser = false;
    this.newUserForm.get('mobileNo')?.enable();
    this.newUserForm.get('countrycode')?.enable();
    this.exstingUserForm.get('mobileNo')?.enable();
    this.exstingUserForm.get('countrycode')?.enable();
  }
  

  isDeviceIdCheckNewUser() {
    console.log("new user device id check", this.newUserForm.get('mobileNo')?.invalid)
    console.log("new user device id check", this.newUserForm.get('deviceId')?.invalid)
    if (
      this.newUserForm.get('mobileNo')?.invalid || this.newUserForm.get('countrycode')?.invalid
    ) {
      console.log("invalid form");
      this.IsnewUsersubmitted = true;
      this.newUserForm.get('mobileNo')?.markAsTouched();
      this.newUserForm.get('countrycode')?.markAsTouched();
      this.loaderService.setLoading(false);
      return;
    }


    const headers = new HttpHeaders({
      'x-auth-token': 'R7XST21TDH=G2=3R9WJDFC6IHE$ZVU9ZHP7ZZ34HWM==EHXBEA',
      'Content-Type': 'application/json'
    });

    let request = {
      mobile: this.newUserForm.value.mobileNo,
    }
    this.loaderService.setLoading(true)
    /*  this.loaderService.setLoading(false);
     this.deviceIdList = this.deviceid;
     this.isdeviceId = true; //if it true the only call new user create api sucesss 
     this.deviceIdList = this.deviceid.filter(
       item => item.device_id && item.device_id.trim() !== ''
     ); */
    this.http.post<any>(this.isDeviceIdUrl, request, { headers }
    ).subscribe({
      next: (res) => {
        console.log('res', res);
        this.isDeviceIdValid = res.success; //for emable create device button and reaming feilds like name  email
        this.loaderService.setLoading(false);
        //  this.newuserDeviceIdresult = res.data;
        if (this.isDeviceIdValid) {
          this.deviceIdList = []
          this.isdeviceId = true; //if it true the only call new user create api sucesss (device id)
          this.deviceIdList = res.data.filter(
            (item: any) => item.device_id && item.device_id.trim() !== ''
          );

          console.log(this.deviceIdList);
          console.log('res', this.isDeviceIdValid);
          // this.newUserForm.get('deviceId')?.disable();
          this.newUserForm.get('mobileNo')?.disable();
          this.newUserForm.get('countrycode')?.disable();
        //  this.enableAndBindFields(res.data);
        } else {
          console.log('no device id found');
          this.deviceIdList = [];
          this.isdeviceId = false;
        }
      }, error: (err) => {
        this.loaderService.setLoading(false);
        console.error(err);
        this.loaderService.setLoading(false);

        let errorMsg = 'Something went wrong. Please try again later.';

        // ✅ Handle validation error structure
        if (err?.error?.errors) {
          const errorsObj = err.error.errors;

          // take first validation message
          const firstKey = Object.keys(errorsObj)[0];
          if (firstKey && errorsObj[firstKey]?.length) {
            errorMsg = errorsObj[firstKey][0];
          }
        }
        // fallback
        else if (err?.error?.message) {
          errorMsg = err.error.message;
        }

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      }
    });

  }
  enableAndBindFields(data: any): void {
    console.log('Enabling fields and binding data:', data);

    const fieldsToEnable = [
      'name',
      'email',
      'flatNo',
      'tower',
      'floor',
      'block',
      'deviceAddress',
      'installedLocation'
    ];

    fieldsToEnable.forEach((field) => {
      this.newUserForm.get(field)?.enable();
    });

    this.newUserForm.patchValue({

      name: `${data.first_name} ${data.last_name}`.trim(),
      email: data.email,
      flatNo: data.flat_no,
      tower: data.tower,
      floor: data.floor,
      block: data.block,
      deviceAddress: data.address,
      installedLocation: data.installed_location
    });
    console.log('Fields enabled and data bound successfully.', this.newUserForm.value);
  }
  MobileNoChekExstingUser() {
    console.log("exsting user clicked")
    this.IsExstingUsersubmitted = true;
    if (this.exstingUserForm!.invalid) {
      this.loaderService.setLoading(false);
      console.log('invalid form');
      return;
    } else {
      console.log("valid form", this.exstinguserDeviceIdresult)
      const formMobile = this.exstingUserForm.get('mobileNo')?.value;
      const apiMobile = this.exstinguserDeviceIdresult?.mobile;
      console.log("valid form")
      console.log(formMobile)
      console.log(apiMobile)
     
     if (formMobile !== apiMobile) {
        console.log('Mobile numbers are different');
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-primary ms-2',
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            allowOutsideClick: false,
            //title: 'Session out',
            text: `The entered mobile number does not match the mobile number linked to the device ID.This Devcie Id is purchased with ${apiMobile}. Would you like to continue or cancel?`,
            icon: 'warning',
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No, Cancel',
            showCancelButton: true,
            timerProgressBar: true,
          })
          .then((result) => {
            console.log(result, 'result');
            if (result.value) {
              console.log(result.value)
              this.exstingUserCreate();

            } else {
              console.log(result.value)
              return;
            }
          });
      } else {
        console.log("mobile number matched")
        this.exstingUserCreate();
      } 
    }
  }

  MobileNoChekNewUser() {
    console.log(this.newUserForm.value)
    console.log(this.newUserForm.getRawValue())
    console.log("new user clicked")
    this.IsnewUsersubmitted = true;
    if (this.newUserForm.invalid) {
      this.loaderService.setLoading(false);
      console.log('invalid form');
      return;
    } else {
      
      const formMobile = this.newUserForm.get('mobileNo')?.value;
      const apiMobile = this.newuserDeviceIdresult?.mobile;
      console.log("valid form")
      console.log(formMobile)
      console.log(apiMobile)
      console.log("valid form")
      console.log(this.newUserForm.getRawValue().mobileNo)
      console.log(this.newuserDeviceIdresult.mobile)
       if (formMobile !== apiMobile) {
       
        console.log("mobile number not matched")
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-primary ms-2',
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            allowOutsideClick: false,
            //title: 'Session out',
            text: `The entered mobile number does not match the mobile number linked to the device ID.This Devcie Id is purchased with ${this.newuserDeviceIdresult.mobile}. Would you like to continue or cancel?`,
            icon: 'warning',
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No, Cancel',
            showCancelButton: true,
            timerProgressBar: true,
          })
          .then((result) => {
            console.log(result, 'result');
            if (result.value) {
              console.log(result.value)
              this.newUserCreate();

            } else {
              console.log(result.value)
              return;
            }
          });
      } else {
        console.log("mobile number matched")
        this.newUserCreate();
      } 
    }
  }

  newUserCreate() {
    this.loaderService.setLoading(true);
    console.log("new user clicked", this.newUserForm.value.deviceId)
    console.log('new user form data', this.newUserForm.value);
    //const uniqueId: this.newUserForm.getRawValue().deviceId
    const createUserData = {
      name: this.newUserForm.value.name,
      timestamp: '',
      email: this.newUserForm.value.email,
      mobile: this.PrimaryCountryCode + ' ' + this.newUserForm.getRawValue().mobileNo,
      //  countrycode: this.newUserForm.value.countrycode,
      flatno: this.newUserForm.value.flatNo,
      floor: this.newUserForm.value.floor,
      block: this.newUserForm.value.block,
      installedlocation: this.newUserForm.value.installedLocation,
      tower: this.newUserForm.value.tower,
      address: this.newUserForm.value.deviceAddress,
      uniqueId: this.newUserForm.getRawValue().deviceId,
      userType: 'Device User',
      isExstingUser: false
    };
    console.log('createUserData', createUserData);
    this.http.post<any>(this.gasLeakRegistrationUrl, createUserData).subscribe({
      next: (res) => {
        console.log('res', res);
        if (res.statusCode === 200) {
          this.newUserForm.reset();
          this.IsnewUsersubmitted = false
          this.deviceIdList = []
          this.loaderService.setLoading(false);
          this.deviceIdList=[]
          this.sucesspopup(res);
        }
      },

      error: (err) => {
        console.error(err);

        this.loaderService.setLoading(false);

        const errorMsg =
          err?.error?.message ||
          err?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      }
    });

  }
  exstingUserCreate() {
    this.loaderService.setLoading(true);
    // this.IsExstingUsersubmitted = true;
    /*  if (this.exstingUserForm.invalid) {
       this.loaderService.setLoading(false);
       console.log('invalid form');
       return;
     } else { */
    console.warn('exsting user form data', this.exstingUserForm.value);
    const createUserData = {
      timestamp: '',
      // name: this.exstingUserForm.value.name,
      //  email: this.exstingUserForm.value.email,
      mobile: this.isExstingUserCountryCode + ' ' + this.exstingUserForm.getRawValue().mobileNo,
      //countrycode: this.exstingUserForm.value.countrycode,
      installedlocation: this.exstingUserForm.value.installedLocation,
      uniqueId: this.exstingUserForm.getRawValue().deviceId,
      userType: 'Project User',
      isExstingUser: true
    };
    console.log('createUserData', createUserData);
    this.http.post<any>(this.gasLeakRegistrationUrl, createUserData).subscribe({
      next: (res) => {
        console.log('res', res);
        if (res.statusCode === 200) {
          this.loaderService.setLoading(false);
          this.exstingUserForm.reset();
          this.deviceIdList=[]
          this.IsExstingUsersubmitted = false;
          this.sucesspopup(res);
        }
      },
      error: (err) => {
        console.error(err);

        this.loaderService.setLoading(false);

        const errorMsg =
          err?.error?.message ||
          err?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      }
    });


  }

  sucesspopup(res: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        allowOutsideClick: false,
        title: res?.message || 'Registration successful',
        text: 'Device registration was successful. You can now log in to the mobile app to access this device.',
        icon: 'success',
        //confirmButtonText: 'Go to Login',
       cancelButtonText: 'Ok',
        //showCancelButton: true,
        timerProgressBar: true,
      })
      .then((result) => {
        console.log(result, 'result');
        if (result.value) {
/*           console.log(result.value)
          //this.logout();//go to login page
          this.router.navigate(['/auth/login']);
          localStorage.clear(); */
          this.exstingUserForm.reset();
          this.IsExstingUsersubmitted = false;
          this.newUserForm.reset();
          this.deviceIdList = []
          this.IsnewUsersubmitted = false
          console.log(result.value)

        } else {
          this.exstingUserForm.reset();
          this.IsExstingUsersubmitted = false;
          this.newUserForm.reset();
          this.deviceIdList = []
          this.IsnewUsersubmitted = false
          console.log(result.value)
          return;
        }
      });
  }
  scannerEnabled = false;
  openScanner() {
    this.isScanning = true;
    console.log('Open scanner (camera / QR / barcode)');
    // later integrate QR / barcode scanner here
    // wait for view to render
    /*  setTimeout(() => {
       if (this.scanner) {
         this.scannerEnabled = true;
       }
     }, 300); */
  }

  closeScanner() {
    this.scannerEnabled = false;
    this.isScanning = false;
  }
  onScanSuccess(result: any) {
    console.log('Scanned value:', result);

    // Set scanned value to Device ID field
    this.individualControls['deviceId'].setValue(result);

    this.closeScanner();
  }
}
